import React from 'react';
import { Button, Form, Modal } from 'reactstrap';
import { toast } from 'react-toastify';

// Formik validation
import { useFormik } from "formik";
import * as Yup from "yup";
import { mainRequestStatus, mainRequestStatusFiltered2, mainRequestStatusFiltered3 } from '../../constants';
import { BaseCustomModal, BaseCustomButton, BaseSelectComponent, GradientDecorationLine } from '../../shared';

export const StatusModal = ({ props, setShowModal, showModal, modalRespInfo, requestStatus, role }) => {

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
          requestStatus: requestStatus?.requestStatus ?? '',
        },
        validationSchema: Yup.object({
            requestStatus: Yup.string().required("Seleccione un estatus de atención"),
        }),
        onSubmit: (values, { resetForm }) => {
            if (values.requestStatus === 'Aceptada') {
                const tracking = requestStatus?.labRequestTracking || [];
                const muestrasPct = tracking.find(x => x.subStepTracking === 'Validación de muestras')?.percentage ?? 0;
                const ensayosPct = tracking.find(x => x.subStepTracking === 'Validación de ensayos')?.percentage ?? 0;
                const informesPct = tracking.find(x => x.subStepTracking === 'Validación de informes')?.percentage ?? 0;

                if (Number(muestrasPct) < 100 || Number(ensayosPct) < 100 || Number(informesPct) < 100) {
                    toast.error("No se puede Aceptar la solicitud porque no se cumple con el 100% de avance en Muestras, Ensayos o Informes.", {
                        autoClose: 6000
                    });
                    return;
                }
            }
            modalRespInfo(values);
            setShowModal(false);
        }
    });

    const { className } = props;

    const toggle = () => {
        setShowModal(!showModal);
    }

    const onClosed = () =>{
        validation.resetForm()
        setShowModal(false);
    }

    const title = (
        <div className='d-flex ms-3 p-0'>
            <label className='m-0 p-0'>
            <h4 className='text-primary m-0 ps-4'>Edición estatus de solicitud general</h4>
            </label>
        </div>
    );

    const buttons = (
        <div className="page-title-box d-flex justify-content-end">
            <BaseCustomButton
                color='success'
                className='rounded-3 me-4'
                onClick={validation.handleSubmit}
                label='Guardar'
                outline={true}
                icon="mdi mdi-content-save me-1"
            />
            <BaseCustomButton
                color='danger'
                className='rounded-3 me-3'
                onClick={toggle}
                label='Cancelar'
                outline={true}
                icon="mdi mdi-close-circle me-1"
            />
        </div>
    );
        

     // The entire content that goes inside the modal
    const childrenBody = (
        <>

        <GradientDecorationLine />

        <Form
            className="form-horizontal mt-3 mb-1"
            onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
            }}
        >
            <div className="mb-1 px-5">
            <label className='text-primary'>Estatus de la Solicitud</label>
            {role === 'Asesor Técnico' ? (
                <BaseSelectComponent
                required
                name="requestStatus"
                placeholder="Estatus de solicitud"
                options={mainRequestStatusFiltered2.map((dir) => ({
                    value: dir.id,
                    label: dir.value,
                }))}
                value={validation.values.requestStatus || ""}
                onChange={(value) => validation.setFieldValue("requestStatus", value)}
                onBlur={validation.handleBlur}
                disabled={false}
                error={validation.errors.requestStatus}
                touched={validation.errors.requestStatus}
                status={validation.errors.requestStatus ? "error" : ''}
                />
            ) : (
                <BaseSelectComponent
                required
                name="requestStatus"
                placeholder="Estatus de solicitud"
                options={
                    requestStatus?.requestStatus === 'En Espera'
                    ? mainRequestStatusFiltered3.map((dir) => ({ value: dir.id, label: dir.value }))
                    : mainRequestStatus.map((dir) => ({ value: dir.id, label: dir.value }))
                }
                value={validation.values.requestStatus || ""}
                onChange={(value) => validation.setFieldValue("requestStatus", value)}
                onBlur={validation.handleBlur}
                disabled={false}
                error={validation.errors.requestStatus}
                touched={validation.errors.requestStatus}
                status={validation.errors.requestStatus ? "error" : ''}
                />
            )}
            </div>

            <div className='mt-5'>
            <GradientDecorationLine />
            {buttons}
            </div>
        </Form>
        </>
    );

    return (
        <>
            <BaseCustomModal
            title={title}                 // We handle the title in childrenBody, or you can put it here
            isModalOpen={showModal}
            handleOk={validation.handleSubmit}
            handleCancel={toggle}
            footer={null}
            afterClose={onClosed} 
            className={className}
            >
            {childrenBody}
            </BaseCustomModal>
        </>
    )
}
